import React, { useMemo } from 'react';
import { SurveySamplesTab } from '../SurveySamplesTab';
import { DashboardTemplates } from '../DashboardTemplates';
import { SurveyEmailSchedule } from '../SurveyEmailSchedule';

// The router-wrapped exports drop their own props (same TS2322 as Form
// elsewhere), so they are typed loosely here on purpose.
const Templates: React.ComponentType<any> = DashboardTemplates as any;
const Schedule: React.ComponentType<any> = SurveyEmailSchedule as any;

export type PanelSection = 'samples' | 'schedule';

type Props = {
  // One panel market row (a child survey): needs id, parentid, shortName,
  // country and useUniqueLinks, all of which getChildSurveys returns.
  market: any;
  section: PanelSection;
  // Schedule only: the market's panel launch settings form, rendered first.
  launchSettings?: React.ReactNode;
};

export const PanelMarketLaunch: React.FC<Props> = ({ market, section, launchSettings }) => {
  // SurveySamplesTab refetches whenever the array identity changes.
  const panelCountries = useMemo(
    () => [{ shortName: market.shortName, countryName: market.country, childSurveyId: market.id }],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [market.id],
  );
  if (section === 'samples') {
    // SurveySamplesTab renders its own "Samples" title.
    return (
      <div className="dx-card">
        <SurveySamplesTab parentSurveyId={market.parentid || market.id} panelCountries={panelCountries} />
      </div>
    );
  }
  return (
    <>
      {launchSettings}
      <div className="dx-card">
        <h6>Email Templates</h6>
        <Templates id={market.id} />
      </div>
      <div className="dx-card">
        <h6>Email Schedule</h6>
        <Schedule id={market.id} isUnique={market.useUniqueLinks} country={market.shortName} />
      </div>
    </>
  );
};
